/**
 * Constants for Int32
 *
 * @typedef {import('./Int32Type.js').BrandedInt32} BrandedInt32
 */

/** @type {-2147483648} Minimum Int32 value (-2^31) */
export const MIN = /** @type {any} */ (-2147483648);

/** @type {2147483647} Maximum Int32 value (2^31 - 1) */
export const MAX = /** @type {any} */ (2147483647);

/** @type {0} Zero value */
export const ZERO = /** @type {any} */ (0);

/** @type {1} One value */
export const ONE = /** @type {any} */ (1);

/** @type {-1} Negative one value */
export const MINUS_ONE = /** @type {any} */ (-1);

/** @type {4} Size in bytes */
export const SIZE = 4;
